import { render } from "./header_notification.vue?vue&type=template&id=bdf5f1d6"
import script from "./header_notification.vue?vue&type=script&lang=js"
export * from "./header_notification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__